/**
 * POST /api/product type list | show — normalize product rows for tag/search UIs.
 */

import { isErpApiSuccess } from "../erpClient";

function isProductLikeObject(obj) {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) return false;
  return (
    obj.id !== undefined ||
    obj.product_id !== undefined ||
    (obj.tag_no !== undefined && obj.tag_no !== null && obj.tag_no !== "")
  );
}

function extractProductsFromData(d) {
  if (!d) return [];
  if (Array.isArray(d.items)) return d.items;
  if (Array.isArray(d.products)) return d.products;
  if (d.product) return [d.product];
  if (Array.isArray(d.records)) return d.records;
  if (d.data && Array.isArray(d.data.items)) return d.data.items;
  if (d.data && Array.isArray(d.data.products)) return d.data.products;
  if (d.data && d.data.product) return [d.data.product];
  if (d.data && Array.isArray(d.data.records)) return d.data.records;
  if (Array.isArray(d)) return d;
  // Single product returned directly on data (no product/products wrapper)
  if (isProductLikeObject(d)) return [d];
  return [];
}

/** List/search response: type "list". */
export function normalizeProductStockListResponse(res) {
  if (!isErpApiSuccess(res)) return [];
  return extractProductsFromData(res.data);
}

/** Single or batch show: type "show" (by id or tag_no). */
export function normalizeProductStockShowResponse(res) {
  if (!isErpApiSuccess(res)) return [];
  return extractProductsFromData(res.data);
}
